import { WebglSettingsConverter } from "../../webgl-settings-converter";
import { VisualizatorSettings } from "../../../settings/visualizator-settings";
import { getItemByField, ObjectCreator } from "../../../../../../../web-graphics";

export class DataSourceWebglSettingsConverter extends WebglSettingsConverter {
  constructor(commonSettings, channelConverter) {
    super();
    this.commonSettings = commonSettings;
    this.channelConverter = channelConverter;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    delete settingsCopy.id_dataSource;
    settingsCopy.id = settings.id_dataSource;
    let commonDataSourceSettings = getItemByField("id", settings.id_dataSource, this.commonSettings.data.sources);
    if (commonDataSourceSettings !== undefined) {
      for (const key of Object.getOwnPropertyNames(commonDataSourceSettings)) {
        if (key == "channels") {
          if (settings.channels !== undefined) {
            settingsCopy.channels = [];
            for (let channelIndex = 0; channelIndex < settings.channels.length; channelIndex++) {
              let channelSettings = settings.channels[channelIndex].copy();
              channelSettings.id_dataSource = settings.id_dataSource;
              channelSettings._commonSettings = getItemByField("id", channelSettings.id_channel, commonDataSourceSettings.channels);
              channelSettings._plotSettings = settings._plotSettings;
              channelSettings._isNeedChannelLeadRay = settings._isNeedChannelLeadRay;
              channelSettings._isSynchronizedScaleX = settings._isSynchronizedScaleX;
              let convertedChannelSettings = this.channelConverter.convert(channelSettings);
              if (convertedChannelSettings !== undefined) {
                settingsCopy.channels.push(convertedChannelSettings);
              }
            }
          }
        } else if (settingsCopy[key] === undefined) {
          if (commonDataSourceSettings[key] instanceof VisualizatorSettings) {
            settingsCopy[key] = commonDataSourceSettings[key].copy();
          } else {
            settingsCopy[key] = ObjectCreator.deepCopy(commonDataSourceSettings[key]);
          }
        }
      }
    }
    return settingsCopy;
  }
}
